(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nv-car-calendar"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-nv-car]').forEach(root=>{
 const form=root.querySelector('form');
 if(form){
  const update=()=>{const checked=form.querySelector('input[name="id"]:checked');if(checked)form.querySelector('[data-car-count]').value=checked.dataset.count;};
  form.addEventListener('change',update);
  form.addEventListener('submit',update,true);
  update();
 }
 root.querySelectorAll('[data-car-image]').forEach(button=>button.addEventListener('click',()=>{
  const image=root.querySelector('.nv-car__hero');
  image.src=button.dataset.carImage;
  image.removeAttribute('srcset');
 }));
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nv-frostfri"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.nv-exact-source').forEach(root=>{const form=root.querySelector('.nf-form');const radios=[...form.querySelectorAll('input[name=id]')];const sticky=root.querySelector('.bx-sticky');function sync(){const radio=radios.find(r=>r.checked);if(!radio)return;root.querySelector('.bx-top-price').textContent=radio.dataset.money;sticky.querySelector('.bx-sticky-price').textContent=radio.dataset.money;sticky.querySelector('output').textContent=radios.indexOf(radio)+1;}radios.forEach(r=>r.addEventListener('change',sync));sticky.querySelectorAll('[data-bx-step]').forEach(b=>b.addEventListener('click',()=>{const index=Math.max(0,Math.min(radios.length-1,radios.findIndex(r=>r.checked)+Number(b.dataset.bxStep)));if(!radios[index].disabled){radios[index].checked=true;sync();}}));root.querySelectorAll('[data-image]').forEach(b=>b.addEventListener('click',()=>{const img=root.querySelector('.nf-main');img.removeAttribute('srcset');img.src=b.dataset.image;}));root.querySelectorAll('[data-bx-tab]').forEach(b=>b.addEventListener('click',()=>{root.querySelectorAll('[data-bx-tab]').forEach(x=>{const selected=x===b;x.setAttribute('aria-selected',String(selected));root.querySelector('#'+x.getAttribute('aria-controls')).hidden=!selected;});}));if('IntersectionObserver'in window)new IntersectionObserver(es=>{sticky.hidden=es[0].isIntersecting;},{threshold:0.05}).observe(form.querySelector('.nf-buy'));form.addEventListener('submit',async event=>{event.preventDefault();const buttons=root.querySelectorAll('.nf-buy,.bx-sticky-buy');const error=root.querySelector('.nf-error');buttons.forEach(b=>b.disabled=true);error.hidden=true;try{const response=await fetch(root.dataset.cart+'/add.js',{method:'POST',body:new FormData(form),headers:{Accept:'application/json'}});if(!response.ok)throw new Error('cart');window.location.assign(root.dataset.cart);}catch{error.hidden=false;buttons.forEach(b=>b.disabled=false);}});sync();});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nv-ornament-calendar"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-glowsketch]').forEach(root=>{const variants=JSON.parse(root.querySelector('[data-gs-variants]').textContent);const strings=JSON.parse(root.querySelector('[data-gs-strings]').textContent);const formatter=new Intl.NumberFormat(root.dataset.locale||'sv',{style:'currency',currency:variants.length?root.dataset.currency:'SEK'});const cards=[...root.querySelectorAll('.gs-bundle')];function update(){cards.forEach(card=>{const n=Number(card.dataset.count);const total=[...card.querySelectorAll('select')].reduce((sum,s)=>{const v=variants[Number(s.value)];if(v?.image){const image=s.closest('label').querySelector('img');image.src=v.image;image.alt=v.label}return sum+(v?v.price/100:[355,395,405][Number(s.value)])},0);card.querySelector('output').textContent=formatter.format(total*(n===2?.85:n===4?.75:1))})}cards.forEach(card=>{card.querySelector('input').addEventListener('change',()=>{cards.forEach(c=>c.classList.toggle('selected',c===card));update()});card.querySelectorAll('select').forEach(s=>s.addEventListener('change',update))});root.querySelectorAll('[data-image]').forEach(b=>b.addEventListener('click',()=>{root.querySelector('.gs-main').src=b.dataset.image}));const buy=root.querySelector('.gs-buy');buy.addEventListener('click',async()=>{if(!variants.length)return;buy.disabled=true;buy.textContent=strings.adding;root.querySelector('.gs-error').textContent='';const counts=new Map();root.querySelectorAll('.gs-bundle.selected select').forEach(s=>{const id=variants[Number(s.value)].id;counts.set(id,(counts.get(id)||0)+1)});try{const prefix=strings.root.endsWith('/')?strings.root:strings.root+'/';const response=await fetch(prefix+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[...counts].map(([id,quantity])=>({id,quantity}))})});if(!response.ok)throw new Error(strings.error);location.assign(strings.cart)}catch{root.querySelector('.gs-error').textContent=strings.error;buy.disabled=false;buy.textContent=strings.add}});update()});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nv-seed-calendar"] && !Shopify.designMode) return;
  try {
    
function initSeedCalendar(scope=document){scope.querySelectorAll('.nv-seed').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='true';const form=root.querySelector('.sc-form');const radios=[...form.querySelectorAll('input[name="id"]')];function sync(){const selected=radios.find(r=>r.checked);if(selected)root.querySelectorAll('.sc-price,.sc-sticky-price').forEach(price=>price.textContent=selected.dataset.money);}radios.forEach(r=>r.addEventListener('change',sync));form.addEventListener('submit',async event=>{event.preventDefault();const button=form.querySelector('.sc-buy');const error=form.querySelector('.sc-error');button.disabled=true;error.hidden=true;try{const response=await fetch(root.dataset.cart+'/add.js',{method:'POST',body:new FormData(form),headers:{Accept:'application/json'}});if(!response.ok)throw new Error('cart');window.location.assign(root.dataset.cart);}catch{error.hidden=false;button.disabled=false;}});sync();});}initSeedCalendar();document.addEventListener('shopify:section:load',event=>initSeedCalendar(event.target));

  } catch(e) { console.error(e); }
})();
})();
